import React, { PureComponent } from 'react';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';

class TooltipBase extends PureComponent {
  popperRef = React.createRef();

  state = {
    open: false,
  };

  handleTooltipClose = () => {
    this.setState({ open: false });
  };

  updatePopperPosition = () => {
    const popper = this.popperRef && this.popperRef.current;

    if (!popper) return;

    if (typeof popper.scheduleUpdate === 'function') {
      popper.scheduleUpdate();
    } else if (typeof popper.update === 'function') {
      popper.update();
    }
  };

  handleTooltipOpen = () => {
    this.setState({ open: true }, this.updatePopperPosition);
  };

  render() {
    const { children, title, className, placement } = this.props;
    return (
      <div className={`tooltip-base-container ${className ? className : ''}`} onClick={e => e.preventDefault()}>
        <ClickAwayListener onClickAway={this.handleTooltipClose}>
          <div>
            <Tooltip
              PopperProps={{
                disablePortal: true,
                popperRef: this.popperRef,
                className: 'tooltip-base-popper',
              }}
              onClose={this.handleTooltipClose}
              open={this.state.open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={title}
              placement={placement}>
              <div onClick={this.handleTooltipOpen}>{children}</div>
            </Tooltip>
          </div>
        </ClickAwayListener>
      </div>
    );
  }
}

export default TooltipBase;
